import React, { useEffect, useRef, useState } from 'react';
import {
  Box, Typography, Table, TableContainer, TableHead,
  TableRow, TableCell, TableBody, IconButton, CircularProgress, Tooltip
} from '@mui/material';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { updateModal, updateInstructionEdit, setCurrentInstruction } from '../Redux/add-instruction';
import CustomAxios from '../utils/CustomAxios';
import { Menu as PrimeMenu } from 'primereact/menu';
import { useGetInstructions } from '../Components/globalFunctions';


export function AddInstructions_table() {
  const toast = useRef(null);
  const dispatch = useDispatch();

  const instructions = useSelector((s) => s.addInstruction.instructionsDetails); // ARRAY
  const loading      = useSelector((s) => s.addInstruction.loading);
  const search       = useSelector((s) => s.addInstruction.searchInstruction);
  const getInstructions = useGetInstructions()

  // ✅ use a ref-map (object), not an array+createRef
  const menuRefs = useRef({});

  const [filteredInstructions, setFilteredInstructions] = useState([]);

  // Filter by name or category name
  useEffect(() => {
    if (Array.isArray(instructions)) {
      const term = (search ?? '').toLowerCase();
      const filtered = instructions.filter((item) => {
        if (!term) return true;
        const nameMatch = item.instruction_name?.toLowerCase().includes(term);
        const categoryName =
          item.category?.category_name ??
          item.instruction_category?.category_name ?? '';
        const categoryMatch = categoryName.toLowerCase().includes(term);
        return nameMatch || categoryMatch;
      });
      setFilteredInstructions(filtered);
    } else {
      setFilteredInstructions([]);
    }
  }, [instructions, search]);

  const handleOpen = (row) => {
    dispatch(setCurrentInstruction(row));   // put row into redux for edit
    dispatch(updateInstructionEdit(true));  // edit mode
    dispatch(updateModal(true));            // open modal
  };

  const confirmDelete = (item) => {
    confirmDialog({
      message: `Do you want to delete the instruction "${item.instruction_name}"?`,
      header: 'Delete Confirmation',
      acceptClassName: 'p-button-danger',
      accept: () => handleDelete(item.instruction_id ?? item.id),
    });
  };

  const handleDelete = async (id) => {
    try {
      await CustomAxios.delete(`instructions/${id}/`);
      toast.current?.show({
        severity: 'success',
        summary: 'Deleted',
        detail: 'Instruction Deleted',
        life: 3000,
      });
      // Optionally refresh:
      await getInstructions();
    } catch (err) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to delete',
        life: 3000,
      });
      console.error(err);
    }
  };

  // helper to get a stable key per row
  const rowKey = (item, index) => item.instruction_id ?? index;

  return (
    <Box>
      <Toast ref={toast} />
      <ConfirmDialog />

      <Typography sx={{ fontSize: '16px', fontWeight: 700, lineHeight: '24px', mb: 2 }}>
        Instruction List
      </Typography>

      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>S No</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Instruction Name</TableCell>
              {/* <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Products</TableCell> */}
              <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredInstructions.length > 0 ? (
              filteredInstructions.map((item, index) => {
                const key = rowKey(item, index);
                return (
                  <TableRow key={key}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.instruction_name}</TableCell>

                    {/* <TableCell>
                      {(item?.instruction_category?.category_image ?? []).map((img, idx) => (
                        <Box
                          key={idx}
                          component="img"
                          src={img}
                          sx={{ width: 40, height: 40, borderRadius: '8px', mr: '10px' }}
                        />
                      ))}
                      {item?.instruction_category?.category_name || 'N/A'}
                    </TableCell> */}
{/* 
                    <TableCell>
                      {item.products?.length
                        ? item.products.map((p) => p.product_name).join(', ')
                        : 'No Products'}
                    </TableCell> */}

                    <TableCell>
                      <PrimeMenu
                        model={[
                          { label: 'Edit', command: () => handleOpen(item) },
                          { label: 'Delete', command: () => confirmDelete(item) },
                        ]}
                        popup
                        appendTo={document.body}         // ✅ ensure popup renders above table container
                        ref={(el) => {                    // ✅ callback ref -> store instance
                          menuRefs.current[key] = el;
                        }}
                      />
                      <Tooltip title="Options" arrow>
                        <IconButton onClick={(e) => menuRefs.current[key]?.toggle(e)}>
                          <MoreHorizSharpIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: 'center', py: 5 }}>
                  {loading ? <CircularProgress /> : 'No Instructions Available'}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
